import styled, { css } from 'styled-components';
import { ParticipantInfoProps } from './ParticipantInfo';

export const ParticipantInfoContainer = styled.div`
	${({ theme }) => css`
		margin-bottom: ${theme.fontSizes.m};
	`}
`;

export const InfoRow = styled.div`
	overflow-wrap: break-word;
	text-align: center;
`;

export const InfoTitle = styled('span')<ParticipantInfoProps>`
	${({ theme, $boldColor }) => css`
		color: ${$boldColor ? $boldColor : theme.colors.neutral[400]};
		font-weight: ${theme.fontWeights.bold};
		text-transform: uppercase;
		font-size: ${theme.fontSizes.s};

		@media ${theme.screens.screenGTS} {
			font-size: ${theme.fontSizes.default};
		}
	`}
`;

export const InfoContent = styled('span')<ParticipantInfoProps>`
	${({ theme, $textColor }) => css`
		color: ${$textColor ? $textColor : theme.colors.brand.text};
		font-weight: ${theme.fontWeights.medium};
		font-size: ${theme.fontSizes.s};

		@media ${theme.screens.screenGTS} {
			font-size: ${theme.fontSizes.default};
		}
	`}
`;

export const InsuranceSection = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 10px;
`;
